<script setup lang="ts">
import AuthScreenLayout from '@/layout/AuthScreenLayout.vue';
import { LockClosedIcon } from '@heroicons/vue/24/outline';
</script>

<template>
  <AuthScreenLayout>
    <div class="flex flex-col items-center" data-test="screen-unauthorised">
      <LockClosedIcon class="mb-3 size-10 text-gray-400" aria-hidden="true" />
      <h1 class="mb-4 text-3xl font-bold text-gray-900">You do not have access</h1>
      <p class="text-gray-500">Contact an administrator.</p>
    </div>
  </AuthScreenLayout>
</template>
